<!--
 * @Author: wangchao
 * @Date: 2021-06-19 
 * @LastEditors: wzc
 * @LastEditTime: 2021-06-02 16:49:10
 * 关键事件包括： 0点球，1进球，2乌龙球，3下场，4黄牌，5红牌，6上场, 7两黄变一红，19换人（eventCodeWeb: 0~7）
 * 换人事件(自定义事件eventCodeWeb:1016)：由同一分钟的下场和上场事件组装而成，因此要保持下场和上场事件挨在一起且下场(3)在前上场(6)在后的顺序且分钟（timeMin）是相同的
 * isShowType: true, //true:展示态势+事件；false:只展示事件；
 * true: 会先取态势数据的个数来判断是否是90还是120分钟，然后在跟关键事件中的最大时间做比对，maxTimeMin最终会取两者最大值，保证态势和事件数据不会画在图表外
 * false:隐藏态势数据，会先取matchInfor里面的overTime，然后在跟关键事件中的最大时间做比对，maxTimeMin最终会取两者最大值，保证事件数据不会画在图表外
 * 【点击图标查看相关事件】文字提示只有在有关键事件的时候才会展示，没有事件则不展示该文字提示
 * 存储主客队球队信息combatObj.length必须等于2才会展示该主题
 * 同一分钟事件现在会重叠

-->
<template>
  <div class="matchState_keyEvent_line">
    <div class="legendTitle">
      <span class="legendItem" v-for="item in combatObj" :key="item.id">
        <i
          class="legendIcon"
          :style="{ backgroundColor: item.legendColor }"
        ></i>
        <span class="legendName" v-text="item.name"></span>
      </span>
    </div>
    <div class="echart_box">
      <div class="left_tip">
        <span class="teamLogo" v-for="item in combatObj" :key="item.id">
          <img :src="item.logo ? item.logo : defaultTeamImg" />
        </span>
      </div>
      <div class="right_echart">
        <div class="lineEcharts">
          <div
            ref="lineEcharts"
            class="lineEchartsDom"
            @click="clickEchartBox"
          ></div>
        </div>
      </div>
    </div>
    <div class="eventArea">
      <template
        v-if="homeMarkPointData.length > 0 || awayMarkPointData.length > 0"
      >
        <span
          class="eventArea_tip"
          v-if="!clickTipEventArr || clickTipEventArr.length == 0"
          v-text="eventAreaTip"
        ></span>
        <span class="eventArea_list" v-else>
          <span
            class="eventItem"
            v-for="event in clickTipEventArr"
            :key="event.eventId"
          >
            <span
              class="eventItem_icon"
              :class="`eventType_${event.eventCodeWeb}`"
            ></span>
            <span
              class="eventItem_timeMin"
              v-text="`${event.matchMinute}′`"
            ></span>
            <span class="eventItem_teamLogo">
              <img :src="event.teamLogo ? event.teamLogo : defaultTeamImg" />
            </span>
            <!-- <span class="eventItem_teamName" v-text="event.teamName"></span> -->
            <span
              class="eventItem_eventInfor"
              v-if="event.eventCodeWeb != eventReplaceCode"
              v-text="event.playerName"
            ></span>
            <span class="eventItem_eventReplace" v-else>
              <span
                v-for="(name, nIndex) in event.playerName"
                :key="nIndex"
                :class="`replace_${nIndex}`"
                v-text="nIndex == 0 ? name : ` / ${name}`"
              ></span>
            </span>
          </span>
        </span>
      </template>
    </div>
    <div class="iconTip">
      <span class="iconItem" v-for="icon in iconTipArrs" :key="icon.type">
        <i :class="icon.type"></i>
        <span class="iconName" v-text="icon.name"></span>
      </span>
    </div>
  </div>
</template>

<script>
// 咪咕的 比赛态势及关键事件
import matchTrend from './migu_keyEvent_line.json' //测试数据
// import { mapState } from 'vuex'
// import echarts_data_mixins from '@/js/mixins/echarts_data.js'
export default {
  name: 'matchState_keyEvent_line',
  // mixins: [echarts_data_mixins],
  data() {
    return {
      eventAreaTip: '点击图标查看相关事件',
      homeBgColor: ['rgba(208, 40, 86, 0.3)', 'rgb(228, 44, 95)'], //主队：【背景色，覆盖色】
      awayBgColor: ['rgba(0, 87, 254, 0.3)', 'rgb(0, 87, 254)'], //客队：【背景色，覆盖色】
      otherColor: ['rgb(255,255,255)', 'rgba(255,255,255,0.4)'], //[虚线颜色，分钟刻度字颜色]
      initFlag: false,
      resizeFlag: false,
      myChart: null,
      yAxisMaxNum: 10,
      yAxisMaxMin: [10, -10],
      coefficientUnit: 100, // 放大的系数
      maxMinTime: 90,
      combatObj: [
        {
          logo: '',
          name: '主队',
          id: '1',
          legendColor: 'rgb(228, 44, 95)',
        },
        {
          logo: '',
          name: '客队',
          id: '2',
          legendColor: 'rgb(0, 87, 254)',
        },
      ],
      homeData: [],
      awayData: [],
      xAxisTimeInterval: 5, //x时间轴 分割
      xAxisTimeIntervalToMaxNum: 90, //x轴刻度线数值显示的最大范围，超过该值则不显示刻度
      iconBase64: {
        point:
          'image://data:image/png;base64,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',
        goal: 'image://data:image/png;base64,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',
        ownGoal:
          'image://data:image/png;base64,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',
        replace:
          'image://data:image/png;base64,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',
        yellowCard:
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUI1RDAzMkY1NDUxMTFFREIzQUFFODhCOThGNUFENTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUI1RDAzMzA1NDUxMTFFREIzQUFFODhCOThGNUFENTMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0MTkyNkI1RTU0NTExMUVEQjNBQUU4OEI5OEY1QUQ1MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QjVEMDMyRTU0NTExMUVEQjNBQUU4OEI5OEY1QUQ1MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrAUZaMAAAC3SURBVHja7NrBDcIwDIXhGLd0AxYgnYIFOgEDdLxOwAJsAQuwQYHIjVgglSLaKPp9yiGK3ifZOVnMzNVUB1dZVQdqUhfm1+X8/YSrmHR7BjWxuWl16k73ZxYovMMtPufN7Txr9ssyxlOf1XIR4ktppzVZ+BQAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQID+BRInj1LCrsmS3PXRow6lLC9pq1MSzQIgoG1rEWAAdissAVbPw/MAAAAASUVORK5CYII=',
        redCard:
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUI1RDAzMzM1NDUxMTFFREIzQUFFODhCOThGNUFENTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUI1RDAzMzQ1NDUxMTFFREIzQUFFODhCOThGNUFENTMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5QjVEMDMzMTU0NTExMUVEQjNBQUU4OEI5OEY1QUQ1MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5QjVEMDMzMjU0NTExMUVEQjNBQUU4OEI5OEY1QUQ1MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlU7AAkAAACsSURBVHja7NrBDYMwDIXh5yoS7NF2ApZgAgZgvE7AEmzQ7hGkSCYbBAlRouj3JZcc3ifZPtncXS3VQ41Vc6BQ+rD2/TO5TyZ1dwbNg7EFs88Q4+8UKGMWub9qmLQkzfl5n2u5jKmmnw5kYSkAAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgABdBjL7VpP2QJbirU8wG5NUzfFS0cwBIKD/1i7AAFXfIw2HueI6AAAAAElFTkSuQmCC',
        offStage:
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACiElEQVRoBe1ZPYgTQRSeNzF6HMbdRbCMv2BhYWEvKAcWJ4KVFt6PhcoJh4UcIqIcIiIixyF3HOLPmd1gqZ2FIKJY2FjaXXQ3CoIIJka84zB5zisW9tTdnezbYIqZZmbevPe+731vshsSIcwwCrAUAFZ0JPhb+QRGtqlLp17NBVumIvW5gyngfzfIdMB0gKmAuUJMAdnhpgNsCZkJTAeYArLDTQfYEjITmA4wBWSHmw6wJWQmMB1gCsgONx1gS8hMkPjTxvKO0fJKBw9qYXRwUcsvdJJwMlwmzRsK654P1hY/xvkkFoDT07L5oPYIBR6LS9BLOwDct3z3lJpjf3NKLIDI4b7TxcbX5ccC8XAvyf6ZW5G+q8ifSSJPMakFkBNuGx9oYvspIh6gfa+HInXHCryJNPLEQ+spBP7DFWtj6QiAeNNz8iAXdMkTF60OhKQb5QkH4ccLdZ32hrZcZ4B523cndZQPcbsqgIJaO0e2tH/hK0SxO0ySywxyzgncyW5zaV2haNJSzfuyvjgwpFTyo3bWWsLtLOQJs+sCKGhw6d4nUZRD6gJ+pj1nSAGzju+dy5qj6ysUBWrtGtvTXu28VO+JzVG77lqCmLGC6nld/3/5ZepAmKi0VHmnmnhIdeJ7aNOdAeQtLnnCYhVACex65W2hIIfVA+0n7XUGSLhpB+6Ujm+aD7sAAtj03n0NBXlUvSdW0wBBwA3b9y6k+eme51IAgdkfKs9QyOPqQ9WOA1cFXrfr3sW48yz23AogcPUofAJCjqsi/v7yBXDNDqqXspBMism1AAKy6m5VSDi7BlTCVSfwLq+x9fumsXV0iv56bZZHrvQ711h+re1j+2MPzYFRwCiQiwK/AW6dkE1GMlycAAAAAElFTkSuQmCC',
        onStage:
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACdklEQVRoBe1WTWjUQBR+E3UR8eAPeNkktLvHInbtVRA9ePLi3av4hyioKCJSERGFFhSKFG967FEUREXF+25W6XE3bncLxVM9CW3zni9gD53dJpNJMqBMLuG9efO+731fMgmAvawCVoHSFHCb4fHSmv9t7JQF4La6NwnwMw9xryyMuK8oo7kXhBcQ8flmbyHg/qBRn96Mi7wXPoAbdM8SwUsg2trbEQ+WJ2uFu7EVJKc0bvDjDCEuANCOka2EeLjcqN0duaaZLGwAL+ieIqLXrH4liYsjnEf9xvidpJosa4UM4AedYxGKd6z8HhVwBn08OFq/rVKbVpP7FPK/9aYQ4Y0q+ZgQAdziU+pJGjmV9VwO+EFvIsLoC1M6qAI2VOOIGX6xbwzlMyS0HfC+L9URo/fa5GOSSNe9Vjibge9QqZYD1fbABVz7ykfl2FBHjQR/J57yd+KaxlbI7EC9vXKIyX8oinxMmk+uq26z+0xngEwO8Au7H6PoEx+XR3TA0vYIIeb6k+NX+M7vudql7MDE4s+9uBG9LYt8TJd7X+Yv+RzflYVVKhwLw90bq8jk4YSaLvmqWNX5pUbtoooTqQ5MEe1aX6UFU+Tj0RHgPP8Qzqs4kTjANJGz0gpfsben82mafTeTP+e1wxdpQyQ+QrXFjr++5pxUgSegGQY7oFIrQPzmx+OSSm1lZ+Vj53C1v11t4gDbbRqVrzY7Pc77o9bkHIP+4n+hfXJeJ058hHQamt5jBzCtuIxnHZAVMR1bB0wrLuNZB2RFTMfWAdOKy3jWAVkR07F1wLTiMp51QFbEdGwdMK24jGcdkBUxHf/zDpgWzOL9dwr8ARaTw1dCUaj9AAAAAElFTkSuQmCC',
        yellow2red:
          'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyVpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDAyNzE5NjU1NDUxMTFFREIzQUFFODhCOThGNUFENTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDAyNzE5NjY1NDUxMTFFREIzQUFFODhCOThGNUFENTMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowMDI3MTk2MzU0NTExMUVEQjNBQUU4OEI5OEY1QUQ1MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowMDI3MTk2NDU0NTExMUVEQjNBQUU4OEI5OEY1QUQ1MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnoJsswAAADKSURBVHja7NoxCsJAEIXhmUV3IbUoqDew8VK5QTpru72XmBt4FLVYYyCQkBG0MUv4XzmwMB+7TIqMppRkTnEyswAC9OcsrGIdwllSqppx4adsTpcqq3Itm2o7rIs8RF0sdpfT6Iw15Wrv71Nj+qjD7TiuN6hifw1fPblcMG0vT/uz8qlHhgIgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAARqm3QPIJO/f+r/0aN+QaswB1S1emBh10TzDehkgQID6eQkwAFlCIwg50khAAAAAAElFTkSuQmCC',
      },
      iconTipArrs: [
        {
          type: 'goal',
          name: '进球',
        },
        {
          type: 'point',
          name: '点球',
        },
        {
          type: 'ownGoal',
          name: '乌龙球',
        },
        {
          type: 'replace',
          name: '换人',
        },
        {
          type: 'yellow2red',
          name: '两黄变一红',
        },
        // {
        //   type: "yellowCard",
        //   name: "黄牌",
        // },
        // {
        //   type: "redCard",
        //   name: "红牌",
        // },
      ],
      eventReplaceCode: 1016,
      homeMarkPointData: [],
      homeMarkLineData: [],
      awayMarkPointData: [],
      awayMarkLineData: [],
      clickTipEventArr: [],
      showTipIntervalMin: 3, //展示前后3分钟的事件
      defaultTeamImg:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAC5klEQVR4Ae3SsQ3CQBREQYPoG3pADqnVNOCNXjoX3tcmo3ccHgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEg8Piev3fYmxK4FXhd1/W5vfgkEASeYWtKYAoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT1bAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB4w8i3waNTi4J/gAAAABJRU5ErkJggg==',
      matchTrend: null,
    }
  },
  mounted() {
    // 开发测试用
    this.matchTrend = matchTrend
    // this.matchTrend = {
    //   data: null,
    //   isShowType: true,
    //   storeKey: "matchTrend",
    //   title: "比赛态势及关键事件",
    // };
    this.isInitEChart()
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      window.removeEventListener('resize', this.onResizeEvent)
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.combatObj = []
    this.homeData = []
    this.awayData = []
    this.homeMarkPointData = []
    this.homeMarkLineData = []
    this.awayMarkPointData = []
    this.awayMarkLineData = []
  },
  // computed: {
  //   ...mapState({
  //     matchInfor: (state) => state.matchInfor.data.matchInfo,
  //     // matchTrend: (state) => state.matchTrend,
  //     defaultTeamImg: (state) => state.defaultTeamImg,
  //     isFloatLayer: (state) => state.isFloatLayer,
  //   }),
  // },
  watch: {
    matchInfor: {
      handler(newVal, oldVal) {
        if (!newVal) {
          return
        }
        if (this.combatObj.length == 0 && newVal.homeName && newVal.awayName) {
          const combatObj = []
          combatObj.push({
            logo: newVal.homeLogo,
            name: newVal.homeName,
            id: newVal.homeId,
            legendColor: this.homeBgColor[1],
          })
          combatObj.push({
            logo: newVal.awayLogo,
            name: newVal.awayName,
            id: newVal.awayId,
            legendColor: this.awayBgColor[1],
          })
          this.combatObj = combatObj
        }
        this.xAxisTimeIntervalToMaxNum = newVal.overtime ? newVal.overtime : 90
      },
      immediate: true,
    },
    matchTrend: {
      handler(newVal, oldVal) {
        if (newVal && newVal.data) {
          this.initdata(newVal.data)
        }
        if (this.initFlag) {
          this.initEcharts()
          if (!this.resizeFlag) {
            this.resizeFlag = true
            this.myChart.resize()
          }
        }
      },
      immediate: true,
    },
    isFloatLayer: {
      handler(newVal, oldVal) {
        if (!newVal && oldVal) {
          if (this.myChart) {
            this.$nextTick(() => {
              this.onResizeEvent()
            })
          }
        }
      },
    },
  },
  methods: {
    initdata(dataList) {
      console.debug('init dataList:', dataList)
      let homeData = []
      let awayData = []
      let homeEventData = []
      let awayEventData = []
      const initSwitchCourtEndMinArr = [45, 90, 105, 120]
      const switchCourtEndMinArr = []
      if (dataList && dataList.length > 2) {
        // 进入了加时赛
        this.maxMinTime = 120
      }
      const totalTimeMinArr = []

      let yAxisMaxNum = 0
      if (!dataList || dataList.length == 0) {
        dataList = []
        dataList.push({
          period: 1,
          list: [
            {
              matchPeriod: 1,
              matchMinute: 1,
              combinedMomentum: 0,
              events: {
                home: [],
                away: [],
              },
            },
          ],
        })
      }
      dataList.forEach((group, gIndex) => {
        if (group.list && group.list.length > 0) {
          const periodHomeData = []
          const periodAwayData = []
          let endMin =
            group.list[group.list.length - 1] &&
            group.list[group.list.length - 1].matchMinute
              ? group.list[group.list.length - 1].matchMinute
              : null
          if (!endMin) {
            if (initSwitchCourtEndMinArr[gIndex]) {
              endMin = initSwitchCourtEndMinArr[gIndex]
            } else {
              console.debug('比赛阶段数据超出了加时赛')
            }
          }
          switchCourtEndMinArr.push(endMin - 0)
          group.list.forEach((item) => {
            // 后端给的值val是 0~1000之间的
            const newVal =
              Math.ceil(
                Math.abs(
                  item.combinedMomentum - 0 ? item.combinedMomentum - 0 : 0
                )
              ) + 1
            if (newVal > yAxisMaxNum) {
              yAxisMaxNum = newVal
            }

            if (item.combinedMomentum > 0) {
              periodHomeData.push(item.combinedMomentum * this.coefficientUnit)
              periodAwayData.push(0)
            } else if (item.combinedMomentum < 0) {
              periodHomeData.push(0)
              periodAwayData.push(item.combinedMomentum * this.coefficientUnit)
            } else {
              periodHomeData.push(0)
              periodAwayData.push(0)
            }
            if (
              item.events &&
              item.events.home &&
              item.events.home.length > 0
            ) {
              item.events.home.forEach((minEvent) => {
                let cell = minEvent
                cell.matchPeriod = item.matchPeriod
                cell.matchMinute = item.matchMinute
                cell.xAxistimeMinId = `${item.matchPeriod}_${item.matchMinute}`
                cell.eventCodeWeb = this.eventCode2eventCodeWeb(
                  minEvent.eventCode - 0
                )
                homeEventData.push(cell)
              })
            }
            if (
              item.events &&
              item.events.away &&
              item.events.away.length > 0
            ) {
              item.events.away.forEach((minEvent) => {
                let cell = minEvent
                cell.matchPeriod = item.matchPeriod
                cell.matchMinute = item.matchMinute
                cell.xAxistimeMinId = `${item.matchPeriod}_${item.matchMinute}`
                cell.eventCodeWeb = this.eventCode2eventCodeWeb(
                  minEvent.eventCode - 0
                )
                awayEventData.push(cell)
              })
            }
          })
          console.debug('awayEventData:', homeEventData, awayEventData)
          totalTimeMinArr.push(group.list ? group.list : [])
          homeData.push(periodHomeData)
          awayData.push(periodAwayData)
        }
      })

      if (this.yAxisMaxNum != yAxisMaxNum && this.matchTrend.isShowType) {
        this.yAxisMaxNum = yAxisMaxNum
        this.yAxisMaxMin = [yAxisMaxNum, -1 * yAxisMaxNum]
      }

      const injuryTimeMinArr = [] //正值：该阶段伤停补时时间；负值：距离常规时间还差多少分钟结束该阶段
      if (this.maxMinTime == 90 && switchCourtEndMinArr.length == 1) {
        switchCourtEndMinArr.push(90)
      }
      if (this.maxMinTime == 120 && switchCourtEndMinArr.length == 3) {
        switchCourtEndMinArr.push(switchCourtEndMinArr[2])
      }
      switchCourtEndMinArr.forEach((item, index) => {
        injuryTimeMinArr.push(item - initSwitchCourtEndMinArr[index])
      })
      const realityPeriodArr = periodDataFormatHandler(
        initSwitchCourtEndMinArr,
        injuryTimeMinArr,
        this.maxMinTime
      )
      const realityPeriodArr1 = realityPeriodArr
      console.debug(
        'periodDataFormatHandler:',
        switchCourtEndMinArr,
        initSwitchCourtEndMinArr,
        injuryTimeMinArr,
        this.maxMinTime,
        realityPeriodArr,
        realityPeriodArr1
      )

      const xAxisTimeSeriesData = [] // [0...45+...,45...90+...,90...105+,105...120]
      let isAddStartMin = 0 //换场时是否需要重新在起点画时间刻度
      realityPeriodArr.forEach((item, index) => {
        if (index === 0) {
          // 因为上半场和下半场有伤停补时，所以需要在开始补0占位；因为上半场有0是必须补0的，下半场要看上半场有没有伤停补时，有伤停补时补0，没伤停补时不补0
          homeData[index] = [].concat([0], homeData[index])
          awayData[index] = [].concat([0], awayData[index])
          totalTimeMinArr[index] = [].concat(
            [
              {
                matchPeriod: index + 1,
                matchMinute: item.minMix[0],
                combinedMomentum: 0,
                events: {
                  home: [],
                  away: [],
                },
              },
            ],
            totalTimeMinArr[index]
          )
        } else {
          if (realityPeriodArr[index - 1].periodState == '3') {
            // 3代表伤停补时
            isAddStartMin = 0
            homeData[index] = [].concat([0], homeData[index])
            awayData[index] = [].concat([0], awayData[index])
            totalTimeMinArr[index] = [].concat(
              [
                {
                  matchPeriod: index + 1,
                  matchMinute: item.minMix[0],
                  combinedMomentum: 0,
                  events: {
                    home: [],
                    away: [],
                  },
                },
              ],
              totalTimeMinArr[index]
            )
          } else {
            isAddStartMin = 1
          }
        }
        let isExport5Min = 5

        if (index === realityPeriodArr.length - 1 || !item.isInjurFlag) {
          // 最后一个节次不多补5分钟
          isExport5Min = 0
        }
        let diff5interval = item.minMix[1] % 5
        let injuryTime5interval =
          diff5interval === 0
            ? item.minMix[1]
            : item.minMix[1] +
              (isExport5Min > 0 ? this.xAxisTimeInterval - diff5interval : 0)
        injuryTime5interval = injuryTime5interval + isExport5Min
        console.debug(
          'injuryTime5interval:',
          index,
          injuryTime5interval,
          isExport5Min,
          item.minMix[1],
          diff5interval,
          isAddStartMin
        )
        for (
          let i = item.minMix[0] + isAddStartMin;
          i <= injuryTime5interval;
          i++
        ) {
          // 补分钟，47分钟补到50分钟,这里会补齐分钟刻度值的占位
          xAxisTimeSeriesData.push(i)
        }
        if (isExport5Min > 0) {
          let addDataNum = 0
          if (diff5interval > 0) {
            addDataNum = this.xAxisTimeInterval - diff5interval
          }
          if (isExport5Min > 0) {
            addDataNum = addDataNum + isExport5Min
          }
          const arr = []
          const timeMinArr = []
          let newMax = 0
          for (let i = 0; i < addDataNum; i++) {
            // 补分钟，47分钟补到50分钟,arr补的比赛态势的值；
            // timeMinArr补的是事件对象占位，这样在后面通过取全部事件totalTimeMinArr的索引即可以得到该事件在x轴的坐标值
            arr.push(0)
            timeMinArr.push({
              matchPeriod: index + 1,
              matchMinute: item.minMix[1] + i + 1,
              combinedMomentum: 0,
              events: {
                home: [],
                away: [],
              },
            })
            newMax = item.minMix[1] + i + 1
          }
          // 补完5的倍数之后，需要把最大值也同步成最新的minMix，realityPeriod
          item.minMix = [item.minMix[0], newMax]
          item.realityPeriod = [
            item.realityPeriod[0],
            newMax,
            item.realityPeriod[2],
          ]
          totalTimeMinArr[index] = [].concat(totalTimeMinArr[index], timeMinArr)
          homeData[index] = [].concat(homeData[index], arr)
          awayData[index] = [].concat(awayData[index], arr)
        }
      })

      // 总的时间刻度头和尾都需要补一分钟，不然前面的覆盖层无法覆盖2边头和尾的最后一个数据
      // xAxisTimeSeriesData.push(
      //   xAxisTimeSeriesData[xAxisTimeSeriesData.length - 1] + 1
      // );

      this.homeData = homeData.flat()
      this.awayData = awayData.flat()
      const allTotalTimeMinArr = []
      totalTimeMinArr.forEach((group) => {
        if (group && group.length > 0) {
          group.forEach((item) => {
            allTotalTimeMinArr.push(item)
          })
        }
      })
      this.totalTimeMinArr = allTotalTimeMinArr
      console.debug('this.homeData:', this.homeData, allTotalTimeMinArr)

      console.debug('realityPeriodArr:', realityPeriodArr, xAxisTimeSeriesData)
      const clientWidth = window.innerWidth || window.screen.width || 375
      const fontSize = Math.round((8 / 375) * clientWidth)
      const xAxisTimeNumArr = [] //存储时间刻度
      const xAxisData = []
      let prevValue = 0
      let periodIndex = 0
      for (let i = 0; i < xAxisTimeSeriesData.length; i++) {
        xAxisData.push(i)
        let realityPeriod = []
        let isInjurFlag = false
        let val = xAxisTimeSeriesData[i]
        if (val > 0) {
          for (let n = periodIndex; n < realityPeriodArr.length; n++) {
            const item = realityPeriodArr[n]
            if (
              item.minMix[0] < val &&
              val <= item.minMix[1] &&
              prevValue >= item.minMix[0]
            ) {
              realityPeriod = item.realityPeriod
              isInjurFlag = item.isInjurFlag
              if (val == realityPeriod[1]) {
                periodIndex++
              }
              break
            }
          }
        }
        console.debug(
          'val:',
          i,
          val,
          isInjurFlag,
          prevValue,
          val % 15,
          realityPeriod
        )
        if (i === 0 || val % 15 === 0) {
          //上半场47分钟，下半场从48分钟开始，48-2-1=45 && 小于等于45分钟时间刻度需要显示，否则都不需要显示
          let value = null
          if (
            realityPeriod.length > 0 &&
            val == realityPeriod[2] &&
            val < realityPeriod[1] &&
            val > realityPeriod[0]
          ) {
            if (prevValue != val) {
              prevValue = val
              value = val == 45 && i == 45 ? '半场' : `${val}′+`
            } else {
              value = `${val}′`
            }
          } else {
            if (val > realityPeriod[2]) {
              value = ''
            } else {
              value = val == 45 && i == 45 ? '半场' : `${val}′`
            }
          }
          console.debug('value:', val, prevValue)
          // xAxisTimeNumArr.push(value);
          xAxisTimeNumArr.push({
            name: `id_${i}`,
            value: value,
            xAxis: i,
            yAxis: (this.yAxisMaxMin[0] + 2) * this.coefficientUnit,
            symbol: 'circle',
            symbolOffset: ['-10%', '-100%'],
            symbolSize: fontSize,
            label: {
              // fontWeight: "bold",
              // fontFamily: "Qatar2022",
              // position: ["50%", "20%"],
              fontSize: fontSize,
              color: this.otherColor[1],
            },
            itemStyle: {
              color: 'transparent',
            },
          })
        } else {
          // xAxisTimeNumArr.push("");
          xAxisTimeNumArr.push({
            name: `id_${i}`,
            xAxis: i,
            yAxis: (this.yAxisMaxMin[0] + 2) * this.coefficientUnit,
            symbol: 'circle',
            // symbolSize: 30,
            label: {
              // show: false,
              // fontWeight: "bold",
              fontSize: fontSize,
              color: this.otherColor[1],
            },
            itemStyle: {
              color: 'transparent',
            },
          })
        }
      }

      this.xAxisTimeNumArr = xAxisTimeNumArr
      this.xAxisData = xAxisData
      console.debug(
        'homeEventData:',
        homeEventData,
        awayEventData,
        xAxisTimeNumArr
      )
      this.apiData2echartData(homeEventData, 'home')
      this.apiData2echartData(awayEventData, 'away')
      function periodDataFormatHandler(initArr, injuryArr, maxMinTime) {
        // 自己组装整场比赛的各个阶段的数据，因为后端只吐有数据的每分钟值，未得到不会吐。比如进行上半场30分钟，后端只给30分钟的数据，上半场后面的和下半场需要占位的时间要前端自己组装。
        // 这里处理完后会根据90分钟和120分钟的比赛组装成2个数组（上下半场）或4个数组（上半场、下半场、加时上、加时下）
        let orignArr = initArr,
          data = []
        if (maxMinTime == 90) {
          orignArr.length = 2
        }
        orignArr.forEach((initMin, index) => {
          let baseNum = 0
          if (index > 0) {
            baseNum = initArr[index - 1]
          }
          let injurMin = injuryArr[index] ? injuryArr[index] : 0
          let endNum = initMin
          let realityNum = endNum + injurMin
          let periodState = ''
          if (injurMin) {
            if (injurMin > 0) {
              periodState = '3' //补时了
            } else if (injurMin < 0) {
              if (endNum - baseNum > Math.abs(injurMin)) {
                periodState = '2' //该阶段比赛已开始，但未结束
              } else {
                periodState = '1' //该阶段未开始，时间刻度占位置使用
              }
            } else {
              periodState = '4' //整点结束比赛
            }
          } else {
            periodState = '1' //该阶段未开始，时间刻度占位置使用
          }

          data.push({
            realityPeriod: [baseNum, realityNum, endNum], //常规时间：[0,30,45] | 伤停补时2min：[0,47,45]
            minMix: [baseNum, realityNum >= endNum ? realityNum : endNum],
            injurMin: injurMin > 0 ? injurMin + 1 : injurMin,
            isInjurFlag: injurMin > 0,
            periodState,
          })
          console.debug('111112:', index, realityNum, endNum, injurMin, data)
        })
        return data
      }
    },
    isInitEChart() {
      this.setTimeoutId = setTimeout(() => {
        if (
          this.$refs.lineEcharts &&
          this.$refs.lineEcharts.clientWidth &&
          this.$refs.lineEcharts.clientHeight
        ) {
          clearTimeout(this.setTimeoutId)
          this.$nextTick(() => {
            // this.initdata();
            this.initEcharts()
            this.initFlag = true
            this.myChart.on('click', 'series.line', (params) => {
              console.debug(params)
              if (
                params.componentType == 'markPoint' &&
                params.seriesIndex != 1
              ) {
                // 点击了 markPoint
                this.isMarkFlag = true
                const clickMarkEvent = params.data
                const splitArr = clickMarkEvent.name.split('_')
                const homeAway = splitArr[0]
                const clickTimeMin = splitArr[1]
                const clickTipEventArr = []
                let markPointEvents = []
                if (homeAway == 'HOME') {
                  markPointEvents = this.homeNewEventData
                }
                if (homeAway == 'AWAY') {
                  markPointEvents = this.awayNewEventData
                }
                if (markPointEvents.length > 0) {
                  const matchPeriod = clickMarkEvent.matchPeriod
                  console.debug('markPointEvents:', markPointEvents)
                  markPointEvents.forEach((event) => {
                    console.debug(
                      'clickTipEventArr:',
                      event.matchMinute,
                      clickTimeMin,
                      event.matchPeriod,
                      matchPeriod
                    )
                    if (
                      Math.abs(event.matchMinute - clickTimeMin) <=
                        this.showTipIntervalMin &&
                      matchPeriod == event.matchPeriod
                    ) {
                      clickTipEventArr.push(event)
                    }
                  })
                }
                this.clickTipEventArr = clickTipEventArr
                console.debug('clickTipEventArr:', this.clickTipEventArr)
              }
            })
            window.addEventListener('resize', this.onResizeEvent)
          })
        } else {
          this.isInitEChart()
        }
      }, 50)
    },
    onResizeEvent() {
      this.myChart.resize()
    },
    handlerKeyEvent(arr) {
      const data = []
      if (arr) {
        arr.forEach((event) => {
          event.eventCodeWeb = this.eventCode2eventCodeWeb(event.eventCode - 0)
          if (
            !event.playerName &&
            (event.eventCodeWeb == 4 || event.eventCodeWeb == 5)
          ) {
          } else {
            data.push(event)
          }
        })
      }
      return data
    },
    apiData2echartData(arr, state) {
      // 生成echarts数据
      // console.debug("生成echarts数据:", arr);
      let maxMinTime = this.maxMinTime
      const yAxisMaxNum = this.yAxisMaxNum
      console.debug(
        'apiData2echartData1:',
        maxMinTime,
        arr,
        state,
        yAxisMaxNum,
        this.yAxisMaxMin
      )
      let yAxisVal = []
      const diffNum = this.matchTrend.isShowType ? 0 : 0.2
      let yAxisKey = yAxisMaxNum * (0.83 - diffNum) * this.coefficientUnit
      let yAxisDynamic = yAxisMaxNum * (0.8 - diffNum) * this.coefficientUnit

      if (state == 'home') {
        yAxisVal = [yAxisKey, yAxisDynamic]
      }
      if (state == 'away') {
        yAxisVal = [-1 * yAxisKey, -1 * yAxisDynamic]
      }
      if (!arr && arr.length == 0) {
        return
      }
      const clientWidth = window.innerWidth || window.screen.width || 375
      const eventIconSize = Math.round((13 / 375) * clientWidth)
      let newEventData = []
      let markPointData = []
      let markLineData = []

      const replaceData = []
      const otherEvent = []
      // console.debug("apiData2echartData12:", arr, this.combatObj);
      const combatObj =
        this.combatObj && this.combatObj.length == 2 ? this.combatObj : null
      arr.forEach((event) => {
        // console.debug("apiData2echartData12-2:", event);
        let newEvent = {}
        if (event.eventCodeWeb == this.eventReplaceCode) {
          newEvent = {
            eventId: `${event.homeAway}_${event.matchMinute}`,
            eventCodeWeb: this.eventReplaceCode,
            eventName: '换人',
            homeAway: event.homeAway,
            matchMinute: event.matchMinute,
            matchPeriod: event.matchPeriod,
            teamName:
              event.homeAway == 'HOME'
                ? combatObj
                  ? combatObj[0].name
                  : ''
                : combatObj
                ? combatObj[1].name
                : '',
            teamLogo:
              event.homeAway == 'HOME'
                ? combatObj
                  ? combatObj[0].logo
                  : ''
                : combatObj
                ? combatObj[1].logo
                : '',
            playerName: [
              event.relatePlayerName ? event.relatePlayerName : '',
              event.playerName ? event.playerName : '',
            ],
          }
          // console.debug("apiData2echartData12-3r:", newEvent);
          replaceData.push(newEvent)
        } else {
          newEvent = event
          newEvent.eventId = `${event.homeAway}_${event.matchMinute}`
          newEvent.matchPeriod = event.matchPeriod
          newEvent.teamName =
            event.homeAway == 'HOME'
              ? combatObj
                ? combatObj[0].name
                : ''
              : combatObj
              ? combatObj[1].name
              : ''
          newEvent.teamLogo =
            event.homeAway == 'HOME'
              ? combatObj
                ? combatObj[0].logo
                : ''
              : combatObj
              ? combatObj[1].logo
              : ''
          // console.debug("apiData2echartData12-3:", newEvent);
          otherEvent.push(newEvent)
        }
      })
      // console.debug("apiData2echartData13:", otherEvent);
      newEventData = [].concat(otherEvent, replaceData).sort((a, b) => {
        return a.matchMinute - b.matchMinute
      })
      // console.debug("apiData2echartData14:", newEventData);

      console.debug('newEventData format:', newEventData)
      if (newEventData.length > 0) {
        const totalTimeMinArr = this.totalTimeMinArr
        newEventData.forEach((event) => {
          let xAxis = 0
          for (let i = 0; i < totalTimeMinArr.length; i++) {
            const cell = totalTimeMinArr[i]
            if (
              cell.matchPeriod == event.matchPeriod &&
              cell.matchMinute == event.matchMinute
            ) {
              xAxis = i
              break
            }
          }

          markPointData.push({
            name: event.eventId,
            matchPeriod: event.matchPeriod,
            //   value: 11,
            xAxis: xAxis,
            yAxis: yAxisVal[0],
            symbolSize: eventIconSize,
            symbolOffset: [0, `${event.homeAway === 'HOME' ? '50%' : '-50'}%`],
            symbol:
              this.iconBase64[this.eventCodeWeb2eventKey(event.eventCodeWeb)],
          })
          // markLineData.push([
          //   {
          //     name: "起点",
          //     xAxis: event.timeMin,
          //     yAxis: 0,
          //   },
          //   {
          //     name: "终点",
          //     xAxis: event.timeMin,
          //     yAxis: yAxisVal[1],
          //   },
          // ]);
        })
      }
      console.debug(
        'newEventData:',
        newEventData,
        markPointData,
        markLineData,
        arr
      )
      if (state == 'home') {
        this.homeNewEventData = newEventData
        this.homeMarkPointData = markPointData
        console.debug('关键事件-主队事件:', this.homeMarkPointData)
        this.homeMarkLineData = markLineData
      }
      if (state == 'away') {
        this.awayNewEventData = newEventData
        this.awayMarkPointData = markPointData
        console.debug('关键事件-客队事件:', this.awayMarkPointData)
        this.awayMarkLineData = markLineData
      }
      newEventData = null
      markPointData = null
      markLineData = null
    },
    eventCode2eventCodeWeb(num) {
      //后端code to 前端code
      let key = null
      switch (num) {
        case 1:
          key = 1
          break
        case 2:
          key = 0
          break
        case 3:
          key = 2
          break
        case 5:
          key = 4
          break
        case 6:
          key = 5
          break
        case 4:
          key = 6
          break
        case 9:
          key = 3
          break
        case 7:
          key = 7
          break
        case 19:
          key = this.eventReplaceCode
          break
        default:
          key = null
          break
      }
      return key
    },
    eventCodeWeb2eventKey(num) {
      let key = ''
      switch (num) {
        case 0:
          key = 'point'
          break
        case 1:
          key = 'goal'
          break
        case 2:
          key = 'ownGoal'
          break
        case 3:
          key = 'offStage'
          break
        case 4:
          key = 'yellowCard'
          break
        case 5:
          key = 'redCard'
          break
        case 6:
          key = 'onStage'
          break
        case 7:
          key = 'yellow2red'
          break
        case this.eventReplaceCode:
          key = 'replace'
          break
        default:
          key = null
          break
      }
      return key
    },
    clickEchartBox(e) {
      console.debug('clickEchartBox:', e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
        this.clickTipEventArr = []
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      const clientWidth = window.innerWidth || window.screen.width || 375
      // const fontSize = Math.round((10 / 375) * clientWidth);
      const arrowSize = Math.round((4 / 375) * clientWidth)
      const homeBgData = []
      const awayBgData = []
      const xAxisData = []
      const homeData = this.matchTrend.isShowType ? this.homeData : []
      const awayData = this.matchTrend.isShowType ? this.awayData : []
      const xAxisTimeNumArr = this.xAxisTimeNumArr
      const homeMarkPointData = this.homeMarkPointData
      const awayMarkPointData = this.awayMarkPointData
      const yAxisMaxMin = this.yAxisMaxMin
      // console.debug("222 maxMinTime:", maxMinTime);
      console.debug('比赛态势-主队态势:', homeData)
      console.debug('比赛态势-客队态势:', awayData)
      for (let i = 0; i <= xAxisTimeNumArr.length; i++) {
        xAxisData.push(i)
        homeBgData.push(yAxisMaxMin[0] * this.coefficientUnit)
        awayBgData.push(yAxisMaxMin[1] * this.coefficientUnit)
      }
      console.debug(
        'initCharts:',
        yAxisMaxMin,
        homeData,
        homeBgData,
        xAxisData,
        xAxisTimeNumArr,
        homeMarkPointData
      )
      let option = {
        title: {
          show: false,
          text: '比赛态势及关键事件',
        },
        tooltip: {
          show: false,
          trigger: 'axis',
        },
        grid: {
          top: '16%',
          left: '3%',
          bottm: '4%',
          right: '3%',
          width: '94%',
          height: '80%',
        },
        // dataZoom: {
        //   type: "inside",
        //   zoomLock: true,
        //   start: 0,
        //   end: 45,
        // },
        legend: {
          show: false,
        },
        xAxis: [
          {
            // type: 'category',
            boundaryGap: false,
            axisLine: {
              show: true,
              symbol: ['none', 'arrow'],
              symbolSize: [arrowSize, arrowSize],
              symbolOffset: [arrowSize * -1, arrowSize],
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: xAxisData,
          },
        ],
        yAxis: [
          {
            boundaryGap: false,
            max: yAxisMaxMin[0] * this.coefficientUnit,
            min: yAxisMaxMin[1] * this.coefficientUnit,
            interval: 5,
            offset: 1,
            axisLabel: {
              show: false,
              formatter: '{value}',
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              symbol: 'arrow',
              symbolSize: [arrowSize, arrowSize],
              symbolOffset: [arrowSize * -1, arrowSize],
            },
          },
          {
            boundaryGap: false,
            max: (yAxisMaxMin[0] + 2) * this.coefficientUnit,
            min: yAxisMaxMin[1] * this.coefficientUnit,
            interval: 5,
            offset: 1,
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '坐标轴占位',
            type: 'line',
            yAxisIndex: 0,
            areaStyle: {
              opacity: 0,
            },
            smooth: true,
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            data: xAxisData,
          },
          {
            name: 'timeHomeBar', //主队覆盖
            type: 'line',
            data: homeBgData,
            yAxisIndex: 1,
            markPoint: {
              label: {
                shwo: true,
              },
              animation: false,
              data: xAxisTimeNumArr, //中间区域的时间数字
            },
            areaStyle: {
              opacity: 0,
            },
            smooth: true,
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
          },
          {
            name: 'homeBg',
            type: 'line',
            data: homeBgData,
            symbol: 'none',
            yAxisIndex: 0,
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: false,
              },
              lineStyle: {
                color: this.otherColor[0],
              },
            },
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            areaStyle: {
              color: this.homeBgColor[0],
            },
          },
          {
            name: 'awayBg',
            type: 'line',
            data: awayBgData,
            symbol: 'none',
            yAxisIndex: 0,
            markLine: {
              silent: true,
              symbol: 'none',
              label: {
                show: false,
              },
              lineStyle: {
                color: this.otherColor[0],
              },
            },
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
            areaStyle: {
              color: this.awayBgColor[0],
            },
          },
          {
            name: 'homeLine',
            type: 'line',
            data: homeData,
            yAxisIndex: 0,
            markPoint: {
              data: homeMarkPointData,
            },
            areaStyle: {
              color: this.homeBgColor[1],
              opacity: 1,
            },
            smooth: true,
            symbol: 'none',
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
          },
          {
            name: 'awayLine',
            type: 'line',
            data: awayData,
            yAxisIndex: 0,
            markPoint: {
              label: {
                shwo: true,
              },
              //   data: [
              //     {
              //       name: "周最低",
              //       // value: -11,
              //       xAxis: 90,
              //       yAxis: -78,
              //       symbolSize: eventIconSize,
              //       // symbolOffset: [0, 0],
              //       symbol: this.iconBase64.ownGoal,
              //     },
              //   ],
              data: awayMarkPointData,
            },
            areaStyle: {
              color: this.awayBgColor[1],
              opacity: 1,
            },
            smooth: true,
            symbol: 'none',
            labelLine: {
              show: false,
            },
            lineStyle: {
              width: 0,
            },
            emphasis: {
              disabled: true,
            },
          },
        ],
      }
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs.lineEcharts)
      }
      setTimeout(() => {
        this.myChart.setOption(option)
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.matchState_keyEvent_line {
  width: 100%;
  background-color: #1c1e23;
  .legendTitle {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    height: 7.73vw;
    .legendItem {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      padding-right: 2.667vw;
      .legendIcon {
        width: 2vw;
        height: 2vw;
      }
      .legendName {
        font-size: 2.667vw;
        color: #fff;
        padding-left: 0.8vw;
      }
    }
  }
  .echart_box {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    .left_tip {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-end;
      flex-direction: column;
      padding-top: 2.667vw;
      width: 10%;
      height: 22.334vw;
      .teamLogo {
        width: 6.667vw;
        height: 6.667vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .right_echart {
      position: relative;
      width: 90%;
      /* height: calc(27.78vw + 2.778vw); */
      height: 37.33vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      &.autoExportPng {
        width: 100%;
        height: 100%;
      }
      .lineEcharts {
        width: 100%;
        height: 100%;
        .lineEchartsDom {
          width: 100%;
          height: calc(100%);
        }
      }
    }
  }
  .eventArea {
    width: 100%;
    padding: 0 3% 30px 12%;

    .eventArea_tip {
      display: block;
      font-size: 20px;
      line-height: 28px;
      color: rgba(255, 255, 255, 0.6);
    }
    .eventArea_list {
      width: 100%;
      display: block;
      .eventItem {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        color: #fff;
        .eventItem_icon {
          width: 26px;
          height: 26px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          &.eventType_0 {
            background-image: url('data:image/png;base64,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');
          }
          &.eventType_1 {
            background-image: url('data:image/png;base64,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');
          }
          &.eventType_2 {
            background-image: url('data:image/png;base64,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');
          }
          &.eventType_1016 {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAADR0lEQVRoBe2YPUwUQRTH3yx7nIHA3RmjMTkQAlpoxPhV2JkoWhkLCwuNQcSCwkYbSq0oLLSxMnJyR2OsNKIJUNnLhyRGo/fBEgkxIaD4wcHePt87XTy43b1djt3TuNPsznv/mfn/3s7sXg7Ab34F/Ar4FahkBYSdxed3XeoE1B5Ya8V0REk0WmuKs9HJVBuocFsGcT5zsHmhWGEdkazT7majY9O7UYUhRDylAg41jaXDTlesGEDL5McGxOURQNzBpgniqIrasFOIigC0TMxuX1KzI+R7zZZDgCNOITwH4Apnte9DVPI9RtvFKYSnAG0Ts7UriM9puxwwMq/HnEB4BtD6HoNzuW9PaLcf041aXX9DjDS+nopY6TwBOI4oL31NPyIjJ6zMrM8RxGFNVYetIFwHoO0iPoynY3Q9u96gnX4pCNcBouOpe2T+oh2zZhqGyKmq4XZyFSA6nuwFhG4zYw7jh4wgXAOIjiZ7UIMehyZLyYsgXAFoGE1202PvLeVmg/k1EPIGJ7EcFgjCoLYsNZuJ6Gv7lAD3m+U5LiRxTUbxzEwTrK5ROecKQGpfi2K2MMdpe2Wt8pyjrfGJfp1mbOhKSf7uvCtnwEtkH8DLahut5T8Bo6p4Gfvnn0D+O4Ct1+oX1MWtZpUTWm4bfXism0B5vqmjyUwUrBK5mmRs2iy/0XgeYFH+HIAVbZB+eO01mqikeR6EsBNQTRuNFyC0LGAX5WJG+XJi+S1U/zY+V72lul0IYWignAXYPErYFckMbLp59rV6Bmrf9c0ABk5SbKYcw4Vj3TbPa60CcCes9KVkCLTTwnPcL6f9Mg9X3Kq87m0NAAfrlNgb4joNAr7oIqfXP+YTD52OdaovAuAJwkr/K1mqOkO3P5xOyOYlSXRGMu6bZ2+GAJyoS/e/lIR0jg72CvftNN18fSbeb0e/GRpTAJ48NBV/Qa/HC2ys1GKVMM+eLAFYEFYSj1GIq/Q/PHLfqLF5UYWXvay87qMkAAsjU/E+lMR1fVDhVTcfSg/EC+Ne3dsCYDN0KO+S+GahsUqbZy+2AVgcUgZuSULc4fu8eYCOSlWePXBzBMADaJ/foDfTfToTHSElkeCY3/wK+BXwK/D/VuAnLxY3ST7X54kAAAAASUVORK5CYII=');
          }
          &.eventType_4 {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABBklEQVRoBe2ayw3CMBBEvTh8OqAAQhNUQAUpgPKogAqoAgqgA36Wce7eHEYjK0iT4yYz3rx3dQh//pi3//Nx2H0/abBsa++bFvNs+dUt43mzvd5r53W14ThL73QJIfc5ZO+TNvNyfNnlVA7b1w5c1IbjrCzee+9az6d2cX+g9ZLoefoBlBwrJwMskmiPDKDkWDkZYJFEe2QAJcfKyQCLJNojAyg5Vk4GWCTRHhlAybFyMsAiifbIAEqOlZMBFkm0RwZQcqycDLBIoj0ygJJj5WSARRLtkQGUHCsnAyySaI8MoORYORlgkUR7XAMW7IaWsnNTu7h3JeIqHudy2SOWyx5sKLPp+wGAKiX6T+Z22wAAAABJRU5ErkJggg==');
          }
          &.eventType_5 {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAA+klEQVRoBe2awQ3CMBAEzyiSCwE6oIhUQAGURwUUQQlQiKVIl4O3L4/VygRp87xkN+eZr83+/CnZ/s9aj4v7NT6o2Tcj5m7WplLul9bevf9NveFnFss/zP0UBT9/FrNbLHHuLXLoDb+zWD59N/rFxi75AUYvCf5PBwDB0WIyQEMJFskACI4WkwEaSrBIBkBwtJgM0FCCRTIAgqPFZICGEiySARAcLSYDNJRgkQyA4GgxGaChBItkAARHi8kADSVYJAMgOFpMBmgowSIZAMHRYjJAQwkWyQAIjhaTARpKsCg3UMoL7OTHNnZJ70rEBYs57ijs5rIHn8pOGleNmR0GJd9K1QAAAABJRU5ErkJggg==');
          }
          &.eventType_7 {
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABC0lEQVRoBe2ZMQ6CQBBFZ0nAgtZoYvQENl7KG9BZ23Ew9QYeRS0QSJawm+2eCjF/G9iBGWbeo1szLRFABNw4+1oUZ2uaqjErxvFf37vc2fK4snW1CT7dNvs0l9Xl9nLyD8IB8vwxdfNDY+0Q+/vBb4drN0S5uy18IPM33XUuzfe9vNpuEivuMRgg8f7sQxpgakUyIAOQgH4hCBCnywBGCAvIAASI02UAI4QFZAACxOkygBHCAjIAAeJ0GcAIYQEZgABxugxghLCADECAOF0GMEJYQAYgQJwuAxghLCADECBO/y8D/TksZvKZAt1ZcWrFPYYGnKvjF1JFvh3zB93xd/re2oPuOK69CAACbyNdGfxuHhgAAAAAAElFTkSuQmCC');
          }
        }
        .eventItem_timeMin {
          width: 65px;
          text-align: right;
          /* font-family: "DINCondensed-Bold"; */
          font-size: 20px;
          line-height: 32px;
          padding: 0 10px 0 0;
        }
        .eventItem_teamLogo {
          width: 32px;
          height: 32px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        /* .eventItem_teamName {
          padding-left: 8px;
          width: 88px;
          font-size: 22px;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        } */
        .eventItem_eventInfor {
          width: calc(100% - 123px);
          padding-left: 30px;
          font-size: 22px;
          line-height: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .eventItem_eventReplace {
          width: calc(100% - 123px);
          padding-left: 30px;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          span {
            position: relative;
            padding-right: 18px;
            font-size: 22px;
            line-height: 30px;
            width: auto;
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &::after {
              position: absolute;
              right: 0;
              top: 50%;
              z-index: 2;
              transform: translateY(-50%);
              content: '\20';
              display: inline-block;
              width: 18px;
              height: 18px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: 100% 100%;
            }
            &.replace_0 {
              &::after {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACiElEQVRoBe1ZPYgTQRSeNzF6HMbdRbCMv2BhYWEvKAcWJ4KVFt6PhcoJh4UcIqIcIiIixyF3HOLPmd1gqZ2FIKJY2FjaXXQ3CoIIJka84zB5zisW9tTdnezbYIqZZmbevPe+731vshsSIcwwCrAUAFZ0JPhb+QRGtqlLp17NBVumIvW5gyngfzfIdMB0gKmAuUJMAdnhpgNsCZkJTAeYArLDTQfYEjITmA4wBWSHmw6wJWQmMB1gCsgONx1gS8hMkPjTxvKO0fJKBw9qYXRwUcsvdJJwMlwmzRsK654P1hY/xvkkFoDT07L5oPYIBR6LS9BLOwDct3z3lJpjf3NKLIDI4b7TxcbX5ccC8XAvyf6ZW5G+q8ifSSJPMakFkBNuGx9oYvspIh6gfa+HInXHCryJNPLEQ+spBP7DFWtj6QiAeNNz8iAXdMkTF60OhKQb5QkH4ccLdZ32hrZcZ4B523cndZQPcbsqgIJaO0e2tH/hK0SxO0ySywxyzgncyW5zaV2haNJSzfuyvjgwpFTyo3bWWsLtLOQJs+sCKGhw6d4nUZRD6gJ+pj1nSAGzju+dy5qj6ysUBWrtGtvTXu28VO+JzVG77lqCmLGC6nld/3/5ZepAmKi0VHmnmnhIdeJ7aNOdAeQtLnnCYhVACex65W2hIIfVA+0n7XUGSLhpB+6Ujm+aD7sAAtj03n0NBXlUvSdW0wBBwA3b9y6k+eme51IAgdkfKs9QyOPqQ9WOA1cFXrfr3sW48yz23AogcPUofAJCjqsi/v7yBXDNDqqXspBMism1AAKy6m5VSDi7BlTCVSfwLq+x9fumsXV0iv56bZZHrvQ711h+re1j+2MPzYFRwCiQiwK/AW6dkE1GMlycAAAAAElFTkSuQmCC');
              }
            }
            &.replace_1 {
              &::after {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACdklEQVRoBe1WTWjUQBR+E3UR8eAPeNkktLvHInbtVRA9ePLi3av4hyioKCJSERGFFhSKFG967FEUREXF+25W6XE3bncLxVM9CW3zni9gD53dJpNJMqBMLuG9efO+731fMgmAvawCVoHSFHCb4fHSmv9t7JQF4La6NwnwMw9xryyMuK8oo7kXhBcQ8flmbyHg/qBRn96Mi7wXPoAbdM8SwUsg2trbEQ+WJ2uFu7EVJKc0bvDjDCEuANCOka2EeLjcqN0duaaZLGwAL+ieIqLXrH4liYsjnEf9xvidpJosa4UM4AedYxGKd6z8HhVwBn08OFq/rVKbVpP7FPK/9aYQ4Y0q+ZgQAdziU+pJGjmV9VwO+EFvIsLoC1M6qAI2VOOIGX6xbwzlMyS0HfC+L9URo/fa5GOSSNe9Vjibge9QqZYD1fbABVz7ykfl2FBHjQR/J57yd+KaxlbI7EC9vXKIyX8oinxMmk+uq26z+0xngEwO8Au7H6PoEx+XR3TA0vYIIeb6k+NX+M7vudql7MDE4s+9uBG9LYt8TJd7X+Yv+RzflYVVKhwLw90bq8jk4YSaLvmqWNX5pUbtoooTqQ5MEe1aX6UFU+Tj0RHgPP8Qzqs4kTjANJGz0gpfsben82mafTeTP+e1wxdpQyQ+QrXFjr++5pxUgSegGQY7oFIrQPzmx+OSSm1lZ+Vj53C1v11t4gDbbRqVrzY7Pc77o9bkHIP+4n+hfXJeJ058hHQamt5jBzCtuIxnHZAVMR1bB0wrLuNZB2RFTMfWAdOKy3jWAVkR07F1wLTiMp51QFbEdGwdMK24jGcdkBUxHf/zDpgWzOL9dwr8ARaTw1dCUaj9AAAAAElFTkSuQmCC');
              }
            }
          }
        }
      }
    }
  }
  .iconTip {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: space-evenly;
    align-items: center;
    .iconItem {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      i {
        width: 3.73vw;
        height: 3.73vw;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        &.goal {
          background-image: url('data:image/png;base64,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');
        }
        &.point {
          background-image: url('data:image/png;base64,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');
        }
        &.ownGoal {
          background-image: url('data:image/png;base64,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');
        }
        &.replace {
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAADR0lEQVRoBe2YPUwUQRTH3yx7nIHA3RmjMTkQAlpoxPhV2JkoWhkLCwuNQcSCwkYbSq0oLLSxMnJyR2OsNKIJUNnLhyRGo/fBEgkxIaD4wcHePt87XTy43b1djt3TuNPsznv/mfn/3s7sXg7Ab34F/Ar4FahkBYSdxed3XeoE1B5Ya8V0REk0WmuKs9HJVBuocFsGcT5zsHmhWGEdkazT7majY9O7UYUhRDylAg41jaXDTlesGEDL5McGxOURQNzBpgniqIrasFOIigC0TMxuX1KzI+R7zZZDgCNOITwH4Apnte9DVPI9RtvFKYSnAG0Ts7UriM9puxwwMq/HnEB4BtD6HoNzuW9PaLcf041aXX9DjDS+nopY6TwBOI4oL31NPyIjJ6zMrM8RxGFNVYetIFwHoO0iPoynY3Q9u96gnX4pCNcBouOpe2T+oh2zZhqGyKmq4XZyFSA6nuwFhG4zYw7jh4wgXAOIjiZ7UIMehyZLyYsgXAFoGE1202PvLeVmg/k1EPIGJ7EcFgjCoLYsNZuJ6Gv7lAD3m+U5LiRxTUbxzEwTrK5ROecKQGpfi2K2MMdpe2Wt8pyjrfGJfp1mbOhKSf7uvCtnwEtkH8DLahut5T8Bo6p4Gfvnn0D+O4Ct1+oX1MWtZpUTWm4bfXism0B5vqmjyUwUrBK5mmRs2iy/0XgeYFH+HIAVbZB+eO01mqikeR6EsBNQTRuNFyC0LGAX5WJG+XJi+S1U/zY+V72lul0IYWignAXYPErYFckMbLp59rV6Bmrf9c0ABk5SbKYcw4Vj3TbPa60CcCes9KVkCLTTwnPcL6f9Mg9X3Kq87m0NAAfrlNgb4joNAr7oIqfXP+YTD52OdaovAuAJwkr/K1mqOkO3P5xOyOYlSXRGMu6bZ2+GAJyoS/e/lIR0jg72CvftNN18fSbeb0e/GRpTAJ48NBV/Qa/HC2ys1GKVMM+eLAFYEFYSj1GIq/Q/PHLfqLF5UYWXvay87qMkAAsjU/E+lMR1fVDhVTcfSg/EC+Ne3dsCYDN0KO+S+GahsUqbZy+2AVgcUgZuSULc4fu8eYCOSlWePXBzBMADaJ/foDfTfToTHSElkeCY3/wK+BXwK/D/VuAnLxY3ST7X54kAAAAASUVORK5CYII=');
        }
        &.yellowCard {
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABBklEQVRoBe2ayw3CMBBEvTh8OqAAQhNUQAUpgPKogAqoAgqgA36Wce7eHEYjK0iT4yYz3rx3dQh//pi3//Nx2H0/abBsa++bFvNs+dUt43mzvd5r53W14ThL73QJIfc5ZO+TNvNyfNnlVA7b1w5c1IbjrCzee+9az6d2cX+g9ZLoefoBlBwrJwMskmiPDKDkWDkZYJFEe2QAJcfKyQCLJNojAyg5Vk4GWCTRHhlAybFyMsAiifbIAEqOlZMBFkm0RwZQcqycDLBIoj0ygJJj5WSARRLtkQGUHCsnAyySaI8MoORYORlgkUR7XAMW7IaWsnNTu7h3JeIqHudy2SOWyx5sKLPp+wGAKiX6T+Z22wAAAABJRU5ErkJggg==');
        }
        &.redCard {
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAA+klEQVRoBe2awQ3CMBAEzyiSCwE6oIhUQAGURwUUQQlQiKVIl4O3L4/VygRp87xkN+eZr83+/CnZ/s9aj4v7NT6o2Tcj5m7WplLul9bevf9NveFnFss/zP0UBT9/FrNbLHHuLXLoDb+zWD59N/rFxi75AUYvCf5PBwDB0WIyQEMJFskACI4WkwEaSrBIBkBwtJgM0FCCRTIAgqPFZICGEiySARAcLSYDNJRgkQyA4GgxGaChBItkAARHi8kADSVYJAMgOFpMBmgowSIZAMHRYjJAQwkWyQAIjhaTARpKsCg3UMoL7OTHNnZJ70rEBYs57ijs5rIHn8pOGleNmR0GJd9K1QAAAABJRU5ErkJggg==');
        }
        &.yellow2red {
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAABC0lEQVRoBe2ZMQ6CQBBFZ0nAgtZoYvQENl7KG9BZ23Ew9QYeRS0QSJawm+2eCjF/G9iBGWbeo1szLRFABNw4+1oUZ2uaqjErxvFf37vc2fK4snW1CT7dNvs0l9Xl9nLyD8IB8vwxdfNDY+0Q+/vBb4drN0S5uy18IPM33XUuzfe9vNpuEivuMRgg8f7sQxpgakUyIAOQgH4hCBCnywBGCAvIAASI02UAI4QFZAACxOkygBHCAjIAAeJ0GcAIYQEZgABxugxghLCADECAOF0GMEJYQAYgQJwuAxghLCADECBO/y8D/TksZvKZAt1ZcWrFPYYGnKvjF1JFvh3zB93xd/re2oPuOK69CAACbyNdGfxuHhgAAAAAAElFTkSuQmCC');
        }
      }
      .iconName {
        padding-left: 0.8vw;
        font-size: 2.667vw;
        line-height: 4vw;
        color: #fff;
      }
    }
  }
}
</style>
